import { Controller } from "@hotwired/stimulus";

// Dismissal for the JM scam disclaimer (shared/jm/_scam_notice).
//
// localStorage, matching the original Drupal banner: once dismissed it stays dismissed for that
// browser, rather than returning next session.
//
// The pre-paint "already dismissed?" check lives inline in the partial — a controller connects
// after paint, so doing it here would flash the banner before hiding it.
export default class extends Controller {
  dismiss() {
    localStorage.setItem("jm-scam-notice", "dismissed");
    this.element.remove();
  }
}
